'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @since 2017-05-10 11:38:14
 * @author vivaxy
 */

var DEVELOPMENT = exports.DEVELOPMENT = 'development';
var LOCAL = exports.LOCAL = 'local';
var BETA = exports.BETA = 'beta';
var PPE = exports.PPE = 'ppe';
var PRODUCTION = exports.PRODUCTION = 'production';


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/configs/envs.js
// module id = 72
// module chunks = 0